module.exports = __webpack_public_path__ + "c7afce22b66eb1440da5c79499ffba3b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/gift.png
// module id = 2657
// module chunks = 0